module.exports = __webpack_public_path__ + "img/thumbnail_LarGibbon_f_normal.6cf63d7d.png";